import { filterMapper } from '@/core/mappers/filter.mapper';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { FilterInfoType } from './../filter-info/filter-info.interface';
import { FilterData } from './filter-data.interface';
import { FilterDataService } from './filter-data.service';

const service = new FilterDataService();

export interface FilterDataState {
   [key: string]: FilterData;
}

const FilterDataStore: Module<FilterDataState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_FILTER_DATA(state, { key, filterData }: { key: string; filterData: FilterData }) {
         state[key] = filterData;
      },
   },
   actions: {
      async getFilterData(context, payload: { slug: string; targetType: FilterInfoType; sourceType: FilterInfoType; sourceId: number }) {
         let response;

         if (payload.sourceType && payload.sourceId) {
            response = await service.getMatchingFilterData(payload.targetType, payload.sourceType, payload.sourceId);
         } else {
            response = await service.getFilterData(payload.targetType);
         }

         const filterData = filterMapper(response.data);
         context.commit('SET_FILTER_DATA', { key: payload.slug, filterData });

         return filterData;
      },
   },
};

export default FilterDataStore;
